define([
    "../../hereMapsModule",
], function (hereMapsModule) {
    "use strict";

    return hereMapsModule.directive("localityHereMaps", [function () {
        return {
            restrict: "E",
            template: "<here-maps maps='here.maps' markers-data='here.markersData'></here-maps>",
            scope: {
                markersPoints: "=",
                onRegisterApi: "=",
                dragendCallback: "=?"
            },
            controller: ["$scope",
                function ($scope) {

                    var markers = null;
                    $scope.onRegisterHereApi = function (api) {
                        markers = api;
                        $scope.onRegisterApi(markers);

                        markers.setDragendAction(dragendAction);
                        markers.setDragendCallback($scope.dragendCallback);

                    };

                    $scope.here = {
                        maps: {
                            hasFullScreen: true
                        },
                        markersData: {
                            markersPoints: $scope.markersPoints,
                            draggable: true,
                            onRegisterApi: $scope.onRegisterHereApi
                        }
                    };

                    function dragendAction(dragendContext) {
                        var target = dragendContext.marker;
                        target.data.geographicInfo.latitude = target.getGeometry().lat;
                        target.data.geographicInfo.longitude = target.getGeometry().lng;
                    }

                }]
        };

    }]);

});

